import React from 'react';
import PropTypes from 'prop-types';
import s from './style.module.scss';
import QrCode from './qrCode';
import { useStores } from '@/stores/storeContext';

export default function LoginModal({ curModal }) {
  const {
    rootStore: { setCurModal },
  } = useStores();

  const handleMaskClick = (e) => {
    if (e.target === e.currentTarget) {
      setCurModal(null);
    }
  };

  return (
    <div className={s.loginModal} onClick={handleMaskClick}>
      <div className={s.content}>
        <div className={s.close} onClick={() => setCurModal(null)} />
        <div className={s.title} />
        <QrCode />
      </div>
    </div>
  );
}

LoginModal.propTypes = {
  curModal: PropTypes.string,
  setCurModal: PropTypes.func.isRequired,
};
